__turbopack_context__.v({
  "numericalRating": "ReviewSummaryCard-module-scss-module__VB_RLW__numericalRating",
  "reviewCardContainer": "ReviewSummaryCard-module-scss-module__VB_RLW__reviewCardContainer",
});
